import { useEffect } from "react"
import { useForm } from "react-hook-form"
import { Button } from "../../component/button.tsx"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../component/generic-components.tsx"

interface RejectionModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (data: { comment: string }) => void
  data?: { approve_comment: string }
  isSubmitting?: boolean
}

export const RejectionModal = ({ isOpen, onClose, onSubmit, data, isSubmitting }: RejectionModalProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<{ comment: string }>()

  useEffect(() => {
    if (isOpen) {
      reset({ comment: data?.approve_comment || "" })
    }
  }, [isOpen, data?.approve_comment, reset])

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader>
          <h3 className="text-lg font-bold">Отклонить</h3>
        </ModalHeader>
        <ModalBody>
          <fieldset className="fieldset">
            <legend className="fieldset-legend">Комментарий</legend>
            <textarea
              id="comment"
              className={`textarea textarea-bordered w-full h-24 ${errors.comment ? "textarea-error" : ""}`}
              {...register("comment", { required: "Комментарий обязателен" })}
            ></textarea>
            {errors.comment && <p className="label text-error">{errors.comment.message}</p>}
          </fieldset>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" className="btn-primary" isProcessing={isSubmitting}>
            Отправить
          </Button>
          <button type="button" className="btn" onClick={onClose}>
            Отмена
          </button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
